import { createContext } from 'react';

import { createProvider } from '@r-client/shared/util/core';

import { IActionModalProps } from '../action-modal/action-modal';

interface IActionModalContext {
  onSetModalProps: (
    props: Omit<IActionModalProps, 'isOpen' | 'onClose'>
  ) => void;
  onOpen: () => void;
  onClose: () => void;
}

const { Provider: ActionModalContextProvider, useData: useActionModalContext } =
  createProvider(
    'ActionModalContext',
    createContext({} as IActionModalContext)
  );

export { ActionModalContextProvider, useActionModalContext };
